import type { IconType } from "react-icons";

import { ContactMethod } from "@/generated/graphql";

import { icons } from "@/app/theme";

export const contactMethodIcon = (contactMethod: ContactMethod): IconType => {
  switch (contactMethod) {
    case ContactMethod.Email:
      return icons.emailFill;
    case ContactMethod.Letter:
      return icons.letterFill;
    case ContactMethod.Call:
      return icons.callFill;
    case ContactMethod.Card:
      return icons.cardFill;
    case ContactMethod.Task:
      return icons.task;
  }
};
